/** Console — electricity meter list (electricity.vue) */
export default {
  deviceElectricity: {
    searchPlaceholder: 'Meter name or serial number',
    bindInfoPlaceholder: 'Binding',
    meterTypePlaceholder: 'Meter type',
    switchStatusPlaceholder: 'Breaker status',
    onlineStatusPlaceholder: 'Online status',
    expand: 'More filters',
    collapse: 'Fewer filters',
    search: 'Search',
    reset: 'Reset',
    export: 'Export',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    sectionList: 'Meter list',
    sectionCard: 'Meter cards',
    add: 'Add',
    sortDefault: 'Default sort',
    viewList: 'List',
    viewCard: 'Cards',
    selectedCount: '{count} selected',
    bindTypeDedicated: 'Dedicated',
    bindTypePublic: 'Shared allocation',
    bindTypeFormula: 'Formula',
    bindTypeAc: 'HVAC meter',
    bindTagDedicated: 'Dedicated',
    bindTagPublic: 'Shared',
    bindTagFormula: 'Formula',
    bindTagAc: 'HVAC',
    switchOff: 'Open',
    switchOn: 'Closed',
    online: 'Online',
    offline: 'Offline',
    prepaid: 'Prepaid',
    prepaidStrong: 'Direct control',
    phaseThreePrimary: 'Three-phase primary',
    phaseThreeSecondary: 'Three-phase secondary',
    phaseSinglePrimary: 'Single-phase primary',
    unbound: 'Unbound',
    colSerial: 'Serial no.',
    colMeterName: 'Meter name',
    colType: 'Type',
    colBindInfo: 'Binding',
    colPayMode: 'Payment mode',
    colPricePlan: 'Tariff plan',
    colPhase: 'Specification',
    colSwitch: 'Breaker',
    colOnline: 'Online',
    colOfflineComment: 'Comment',
    colSyncTime: 'Last reading time',
    colCreateTime: 'Created',
    cardSerial: 'Serial no.',
    cardBindInfo: 'Binding',
    cardPricePlan: 'Tariff plan',
    cardLatestReading: 'Latest reading',
    opOpen: 'Open',
    opClose: 'Close',
    opEdit: 'Edit',
    opDetail: 'Details',
    opColumn: 'Actions',
    copySerialTip: 'Click to copy',
    priceSharp: 'Sharp',
    pricePeak: 'Peak',
    priceFlat: 'Shoulder',
    priceValley: 'Off-peak',
    emptyNoData: 'No data',
    dialogEditTitle: 'Edit meter',
    dialogAddTitle: 'Add meter',
    labelSerial: 'Serial no.',
    labelImei: 'IMEI',
    labelMeterName: 'Meter name',
    labelMeterType: 'Meter type',
    labelPayMode: 'Payment mode',
    labelPhase: 'Phase',
    labelCt: 'CT',
    labelPt: 'PT',
    labelPricePlan: 'Tariff plan',
    placeholderSerial: 'Enter serial number',
    placeholderImei: 'Enter IMEI',
    placeholderMeterName: 'Enter meter name',
    placeholderSelectMeterType: 'Select meter type',
    placeholderSelectPayMode: 'Select payment mode',
    placeholderSelectPhase: 'Select phase',
    placeholderCt: 'CT ratio',
    placeholderPt: 'PT ratio',
    placeholderSelectPrice: 'Select tariff plan',
    priceLineMeta: 'Peak: {peak} Flat: {flat} Valley: {valley}',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    saving: 'Saving…',
    payTypeDialogTitle: 'Confirm',
    payTypeDialogBody: 'This meter is in prepaid mode. Switch to direct control before operating the breaker.',
    payTypeDialogAsk: 'Change now?',
    switchVerifyMeter: 'Meter',
    switchVerifyAction: 'Action',
    switchVerifyPhone: 'Phone',
    switchVerifyCode: 'Code',
    placeholderVerifyCode: 'Enter verification code',
    sendSmsCode: 'Send code',
    ruleSerial: 'Serial number is required',
    ruleMeterName: 'Meter name is required',
    ruleBindType: 'Select a meter type',
    rulePayMode: 'Select a payment mode',
    rulePhase: 'Select a phase type',
    switchVerifyTitleBase: 'Breaker operation',
    switchVerifyTitleFmt: 'Verify {action}',
    actionOpen: 'open',
    actionClose: 'close',
    errPriceList: 'Failed to load tariff plans',
    errTenantList: 'Failed to load tenants',
    errFetchList: 'Failed to load data',
    errFetchMeters: 'Failed to load meters',
    successSaveUpdate: 'Saved',
    successSaveAdd: 'Created',
    errOperation: 'Operation failed',
    infoSearchingSerial: 'Searching for meter with serial {serial}…',
    warnNoPhone: 'No phone number on file',
    successCodeSent: 'Code sent',
    errSendCode: 'Failed to send code',
    warnEnterCode: 'Enter the verification code',
    confirmSwitchTitle: 'Notice',
    confirmSwitchMsg: 'Run {action} on meter "{name}"?',
    btnOk: 'OK',
    btnCancelShort: 'Cancel',
    successSwitch: '{action} succeeded',
    errSwitch: '{action} failed',
    successPayTypeUpdate: 'Payment mode updated',
    errUpdate: 'Update failed',
    errPayTypeUpdate: 'Failed to update payment mode',
    warnNothingToCopy: 'Nothing to copy',
    successSerialCopied: 'Serial copied',
    errCopy: 'Copy failed',
    warnTenantNotBound: 'This meter is not bound to a tenant',
    warnNoExportData: 'No data to export',
    warnNoSelectedExport: 'Please select rows to export',
    successExported: 'Exported {count} row(s)',
    successExportedLimit: '{total} row(s) in total, first {count} row(s) exported',
    errExport: 'Export failed',
    exporting: 'Exporting...',
    exportSheetName: 'Meters',
    exportFilePrefix: 'meters',

    meterDrawerTitle: 'Details',
    meterDrawerColId: 'ID',
    meterDrawerColInstallLoc: 'Install location',
    meterDrawerBindCardTitle: 'Binding',
    meterDrawerNoBind: 'No binding information',
    meterDrawerNoPricePlan: 'No tariff plan',
    meterDrawerPricePlanLabel: 'Tariff plan',
    meterDrawerMetricRealtimeP: 'Real-time power (kW)',
    meterDrawerMetricPf: 'Real-time power factor',
    meterDrawerMetricMonthPeak: 'Monthly peak power (kW)',
    meterDrawerMetricYesterdayKwh: 'Yesterday usage (kWh)',
    meterDrawerSectionPowerCurve: 'Power curve',
    meterDrawerDatePlaceholder: 'Pick date',
    meterDrawerViewTable: 'Table',
    meterDrawerViewLineChart: 'Line chart',
    meterDrawerColCollectTime: 'Collected at',
    meterDrawerEmptyPower: 'No power data',
    meterDrawerSectionUsage: 'Recent usage',
    meterDrawerLinkFullReport: 'Open full report',
    meterDrawerColDate: 'Date',
    meterDrawerColTotalFee: 'Total fee (¥)',
    meterDrawerColTotalKwh: 'Total kWh',
    meterDrawerColTierSharp: 'Sharp (kWh)',
    meterDrawerColTierPeak: 'Peak (kWh)',
    meterDrawerColTierFlat: 'Shoulder (kWh)',
    meterDrawerColTierValley: 'Off-peak (kWh)',
    meterDrawerGroupStartReading: 'Start reading',
    meterDrawerGroupEndReading: 'End reading',
    meterDrawerColSubTime: 'Time',
    meterDrawerColSubTotal: 'Total kWh',
    meterDrawerColSubSharp: 'Sharp',
    meterDrawerColSubPeak: 'Peak',
    meterDrawerColSubFlat: 'Shoulder',
    meterDrawerColSubValley: 'Off-peak',
    meterDrawerEmptyUsage: 'No usage statistics',
    meterDrawerChartMax: 'Max',
    meterDrawerChartMin: 'Min',
    meterDrawerWarnPrepaidNoSwitch: 'Breaker cannot be operated in prepaid mode',
    batchSetOfflineType: 'Batch set offline type',
    batchOfflineTypeDialogTitle: 'Batch set offline type',
    batchOfflineTypeLabel: 'Offline type',
    batchOfflineTypeComment: 'Comment',
    phOfflineComment: 'Enter a comment',
    offlineTypeOnline: 'Online',
    offlineTypeAbnormal: 'Abnormal offline',
    offlineTypeNormal: 'Normal offline',
    batchOfflineTypeSelectedTip: '{count} meters selected',
    warnNoMeterSelected: 'Select meters first',
    warnOnlineMeterSelected: '{count} online meter(s) selected; only offline meters can be set',
    warnSelectOfflineType: 'Select an offline type',
    successBatchOfflineType: 'Offline type updated',
    errBatchOfflineType: 'Failed to update offline type'
  }
}
